import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import PicMa from "../../../../../../assets/images/live.png";
import { io } from "socket.io-client";
import Picker from "emoji-picker-react";
import { useFilePicker } from "use-file-picker";
import Message from "../../../../../Admin/FanbaseGroup/FanBaseComponents/Message";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";

const FanBaseMessengerStar = ({ group_id, color, chatUser, groupData }) => {
  const { shoketUrl } = useContext(serverInfo);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef();
  const socket = useRef();
  const params = useParams();
  const [showPicker, setShowPicker] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  const onEmojiClick = (event, emojiObject) => {
    setNewMessage((prevInput) => prevInput + emojiObject.emoji);
    setShowPicker(false);
  };

  useEffect(() => {
    console.log('star fan group details', groupData)

    socket.current = io(shoketUrl);
    socket.current.emit("join_room", groupData?.room_id);

    // socket.current.on("getGroupMessage", (data) => {
    //   setArrivalMessage({
    //     sender_id: data.senderId,
    //     sender_name: data.senderName,
    //     sender_image: data.senderImage,
    //     position: data.position,
    //     receiver_id: data.receiverId,
    //     text: data.text,
    //     createdAt: Date.now(),
    //   });
    // });

    axios
      .get(`/api/mobile/fan-group-chat-history/${groupData.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setArrivalMessage(res.data.chat_history);
        }
      });


  }, [groupData]);

  useEffect(() => {
    axios.get(`/api/user_info`).then((res) => {
      if (res.data.status === 200) {
        setUserInfo(res.data.users);
      }
    });

    axios.get(`/api/group/message/${group_id}`).then((res) => {
      if (res.data.status === 200) {
        setMessages(res.data.message);
      }
    });
  }, [group_id]);

  useEffect(() => {
    // arrivalMessage && setMessages((prev) => [...prev, arrivalMessage]);
    socket.current.on("recive_message", (data) => {
      setMessages((prv) => {
        return [...prv, data];
      });
    });


  }, [arrivalMessage]);

  const handleSubmit = async (e) => {
    // e.preventDefault();

    // if (newMessage) {
    //   const receiverId = 0;

    //   socket.current.emit("sendGroupMessage", {
    //     senderId: userInfo.id,
    //     senderName: userInfo.first_name,
    //     senderImage: userInfo.image,
    //     position: color,
    //     receiverId,
    //     text: newMessage,
    //   });

    //   const fData = new FormData();

    //   fData.append("sender_id", userInfo.id);
    //   fData.append("sender_name", userInfo.first_name);
    //   fData.append("sender_image", userInfo.image);
    //   fData.append("position", color);
    //   fData.append("group_id", group_id);
    //   fData.append("text", newMessage);

    //   try {
    //     axios.post(`/api/group/message`, fData).then((res) => {
    //       if (res.data.status === 200) {
    //         setMessages([...messages, res.data.message]);
    //       }
    //     });
    //     setNewMessage("");
    //   } catch (err) {
    //   }
    // }

    e.preventDefault();

    let time =
      new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes() + ":" + new Date(Date.now()).getSeconds();
    let messageData = {
      sender_id: userInfo?.id,
      room_id: groupData?.room_id,
      sender_name: userInfo?.first_name,
      sender_image: userInfo?.image,
      group_id: groupData?.id,
      position: 0,
      text: newMessage,
      time: time,
      status: 1,
    };

    if (userInfo) {
      socket.current.emit("send_message", messageData);
      setMessages((prv) => {
        return [...prv, messageData];
      });
      setNewMessage("");
    }

  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const [openFileSelector, { filesContent, loading, errors }] = useFilePicker({
    readAs: "DataURL",
    accept: "image/*",
    multiple: true,
    limitFilesConfig: { max: 2 },
    maxFileSize: 50,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (errors.length) {
    return <div>Error...</div>;
  }

  return (
    <div className="MessengerHead3">
      <div className=" MessengerBody py-3 ps-2 text-light">
        <h6 className="fw-bold mx-2">Group inbox</h6>

        <div className="top-right-messenger">
          {/* <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span> */}
          <span className="messengerUser"> {chatUser} Users</span>
        </div>
      </div>

      <div className="chatBoxTop container MessengerBodyText py-2 ps-2 text-light">
        {messages.map((m) => (
          <div ref={scrollRef}>
            <Message message={m} userInfo={userInfo} />
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <div className="d-flex MessengerFooter  p-2 text-light">
          <div className="IconMessage col-md-2 me-3 d-flex">
            <i
              onClick={() => openFileSelector()}
              className="text-light IconMessageT m-1 fa-solid fa-image f-25"
            ></i>

            <i
              onClick={() => setShowPicker((val) => !val)}
              className="text-light IconMessageT fa-solid fa-face-smile f-25 ms-2 mt-1"
            ></i>
          </div>

          <div className="IconMessage col-md-7 d-flex">
            {filesContent.map((file, index) => (
              <div key={index}>
                <div className="MessageWidth px-3">
                  <img
                    className="img-file"
                    alt={file.name}
                    src={file.content}
                  ></img>
                </div>

                <br />
              </div>
            ))}
            <input
              type="text"
              className="MessageWidth px-3"
              placeholder="type text..."
              onChange={(e) => setNewMessage(e.target.value)}
              value={newMessage}
            />
          </div>

          <div
            className="IconMessage col-md-1 d-flex ms-2"
            onClick={handleSubmit}
          >
            <i className=" mt-2 text-light IconMessageT SendT text-left fa-brands fa-telegram f-25"></i>
          </div>
        </div>
      </form>

      {showPicker && (
        <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
      )}
    </div>
  );
};

export default FanBaseMessengerStar;
